import { render, staticRenderFns } from "./CbsWidgetQuickadd.vue?vue&type=template&id=eafe5898&scoped=true"
import script from "./CbsWidgetQuickadd.vue?vue&type=script&lang=js"
export * from "./CbsWidgetQuickadd.vue?vue&type=script&lang=js"
import style0 from "./CbsWidgetQuickadd.vue?vue&type=style&index=0&id=eafe5898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafe5898",
  null
  
)

export default component.exports